import { Type } from '@nicejob-library/schema';

/* eslint-disable @nicejob/snake-case */

export const CONSENT_SOURCE = 'NiceJob app' as const;
export const PRIVACY_POLICY_URL = 'https://www.paystone.com/legal';

/**
 * Communication preferences captured during user registration.
 * Used for GDPR, CASL, and CPRA compliance.
 */
export const CommunicationPreferences = Type.object({
    additionalProperties: false,
    description: 'Communication and marketing consent preferences.',
    title: 'CommunicationPreferences',
    required: ['marketing_opt_in', 'ad_targeting_consent', 'consent_timestamp', 'consent_source'],
    properties: {
        marketing_opt_in: Type.boolean({
            description:
                'Whether the user has opted in to receive marketing communications (tips, product updates, offers).',
        }),
        ad_targeting_consent: Type.boolean({
            description:
                'Whether the user consents to sharing limited information with advertising platforms.',
        }),
        consent_timestamp: Type.date({
            description: 'ISO 8601 timestamp when consent was captured.',
        }),
        consent_source: Type.string({
            description: 'Source where consent was captured.',
            enum: [CONSENT_SOURCE] as const,
        }),
    },
});
